// ============================================
// Path: /frontend/src/components/PropertiesSearchFilter.jsx
// Purpose: Search filter for properties page (type, location)
// this code relies on component nested jsx to achieve its effects
// ============================================

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Search } from 'lucide-react';
import { counties } from '../lib/locations';
import { propertyTypes } from '../lib/categories';
import { NestedSelect } from './NestedSelect';

export function PropertiesSearchFilter() {
  console.log('[PropertiesSearchFilter] Component mounted');

  const navigate = useNavigate();
  const [location, setLocation] = useState('');
  const [type, setType] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    console.log('[PropertiesSearchFilter] Submitting search:', { type, location });

    const params = new URLSearchParams();
    params.append('category', 'property');

    if (type) {
      const [mainType, subType] = type.split('/');
      params.append('type', mainType);
      console.log('[PropertiesSearchFilter] Added type filter:', mainType);
      
      if (subType) {
        params.append('subType', subType);
        console.log('[PropertiesSearchFilter] Added subType filter:', subType);
      }
    }

    if (location) {
      const [county, subCounty] = location.split('/');
      if (county) {
        params.append('county', county);
        console.log('[PropertiesSearchFilter] Added county filter:', county);
      }
      if (subCounty) {
        params.append('subCounty', subCounty);
        console.log('[PropertiesSearchFilter] Added subCounty filter:', subCounty);
      }
    }

    const searchUrl = `/search?${params.toString()}`;
    console.log('[PropertiesSearchFilter] Navigating to:', searchUrl);
    navigate(searchUrl);
  };

  return (
    <Card className="bg-muted/40 shadow-md hover:shadow-lg transition-shadow duration-300">
      <CardContent className="p-3 sm:p-4 md:p-6">
        <form onSubmit={handleSearch} className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 items-end">
          <NestedSelect
            id="type"
            label="Category"
            value={type}
            onValueChange={setType}
            options={propertyTypes}
            placeholder="Any Category"
            isLocation={false}
          />

          <NestedSelect
            id="location"
            label="Location"
            value={location}
            onValueChange={setLocation}
            options={counties}
            placeholder="Any Location"
            isLocation={true}
          />

          <div className="md:col-span-2 flex justify-end">
            <Button 
              type="submit" 
              size="default" 
              className="w-full text-xs sm:text-sm h-9 sm:h-10 shadow-sm hover:shadow-md transition-all duration-200"
            >
              <Search className="mr-2 w-4 h-4" />
              Find Properties
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}